import { combineReducers } from '@reduxjs/toolkit';
import grid from "./gridEdit/gridReducer";
import zoom from './zoom/zoomReducer';
import drag from './drag/dragReducer';
import auth from './auth/authReducer';
import map from './map/mapReducer';
import measure from './measure/measureReducer';

export default combineReducers({ grid, zoom, drag, auth, map, measure });
